export const timeAnswer = 20 // 20 seconds pour réponse à question